export const FEATURE_NAME = 'LocationChest';
